import { getByAuthService } from "../../../../../../function/helper";

const doSearch = async (src, set, done) => {
  if (src.length < 4) {
    return;
  }

  set(true);
  const response = await getByAuthService("/address/v1/external/search", {
    srcinput: src,
  });

  set(false);

  if (response.status === 200) {
    done(response.data.data);
  }
};

export default doSearch;
